import React, { useState, FC, ReactNode } from 'react';
import { PricingContext } from './context';
import { DefaultconversionListFormData } from 'pages/main-store/brand-chefs/manage-meals/add-manage-meals';
import {
  ActiveType,
  ConversionListFormType,
  ConversionListType,
  ConversionItemType
} from 'models/pricing.model';
import { BaseMealFormType, MealPricingFormType } from 'models/pricing.model';
import { DefaultBaseMealFormData } from 'pages/main-store/pricing/base-meals/edit-base-meals';
import { DefaultMealPricingFormData } from 'pages/main-store/pricing/meal-pricing/edit-meal-pricing';

export const DefaultVendorToEdit = {
  account_name: '',
  account_number: '',
  address: '',
  archived: false,
  bank_name: '',
  created_at: '',
  id: '',
  name: '',
  outstanding: '',
  phone_number: '',
  total_paid: '',
  updated_at: '',
  items: []
};
const PricingProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [conversionListFormData, setConversionListFormData] = useState<ConversionListFormType[]>([
    DefaultconversionListFormData
  ]);
  const [itemToEdit, setItemToEdit] = useState<ConversionListType[]>([]);
  const [active, setActive] = useState<ActiveType | null>('manual');
  const [step, setStep] = useState(1);
  const [selectedConversionItem, setSelectedConversionItem] = useState<ConversionItemType | null>(
    null
  );
  const [baseMealsFormData, setBaseMealFormData] = useState<BaseMealFormType[]>([
    DefaultBaseMealFormData
  ]);
  const [selectedBaseMeal, setSelectedBaseMeal] = useState<BaseMealFormType | null>(null);

  const [mealPricingFormData, setMealPricingFormData] = useState<MealPricingFormType[]>([
    DefaultMealPricingFormData
  ]);
  const [selectedMealPricing, setSelectedMealPricing] = useState<MealPricingFormType | null>(null);

  return (
    <PricingContext.Provider
      value={{
        conversionListFormData,
        setConversionListFormData,
        setBaseMealFormData,
        baseMealsFormData,
        itemToEdit,
        setItemToEdit,
        active,
        setActive,
        step,
        setStep,
        selectedConversionItem,
        setSelectedConversionItem,
        selectedBaseMeal,
        setSelectedBaseMeal,

        mealPricingFormData,
        setMealPricingFormData,
        selectedMealPricing,
        setSelectedMealPricing
      }}>
      {children}
    </PricingContext.Provider>
  );
};

export default PricingProvider;
